<template>
  <panel v-if="warnings.length">
    <div class="row form-group">
      <div class="col-12">
        <h2 class="font-weight-bold mt-1 mb-0">
          Uwagi:
        </h2>
      </div>

      <div class="row form-group">
        <ul class="alert alert-warning warnings-list list--alert " role="alert">
          <li v-for="(warning, index) in warnings" :key="index">
            {{ warning }}
          </li>
        </ul>
      </div>
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';

// @vuese
// Wyświetalnie warringów dokumentu
// @Group displayComponents
export default {
  components: {
    Panel
  },
  computed: mapState({
    warnings: state => state.document.data.data.warnings
  })
};
</script>

<style>
.list--alert {
  font-size: 1rem;
  margin: 1rem 2rem;
  padding: 1rem 2rem !important;
}
</style>
